import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { UpgradeModal } from './UpgradeModal';

export const BlockedActionDialog = ({ open, onOpenChange, resourceType, limit, wedding, onUpgradeSuccess }) => {
  const getContextualMessage = () => {
    const messages = {
      guests: `You've added the maximum ${limit} guests allowed in trial.\nUpgrade to manage your full guest list.`,
      vendors: `You've added the maximum ${limit} vendors allowed in trial.\nUpgrade to manage your full vendor list.`,
      events: `Trial allows only ${limit} event.\nUpgrade to add your complete wedding timeline.`,
      tasks: `Trial allows only ${limit} tasks.\nUpgrade to manage your full checklist.`,
      menu_items: `You've added the maximum ${limit} menu items allowed in trial.\nUpgrade to plan your complete menu.`,
      invitation_emails: `Trial allows only ${limit} emails.\nUpgrade to send unlimited invitations and updates.`,
      accommodation_emails: `Trial allows only ${limit} emails.\nUpgrade to send unlimited accommodation details.`
    };
    
    return messages[resourceType] || `Trial limit reached. Upgrade to continue.`;
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-full bg-orange-100 dark:bg-orange-900/20">
              <AlertTriangle className="h-5 w-5 text-orange-600 dark:text-orange-400" />
            </div>
            <AlertDialogTitle>🚧 Trial limit reached</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="pt-2 whitespace-pre-line">
            {getContextualMessage()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <UpgradeModal
            wedding={wedding}
            trigger={
              <Button className="gradient-primary">
                Upgrade Wedding
              </Button>
            }
            onUpgradeSuccess={onUpgradeSuccess}
          />
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
